import React from 'react';
import { AmountOperationBox } from './style'
import {Button} from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AmountOperation = ({ title, button}) => {

    const notify = () => toast.dark("At the moment it is not possible to redeem !", {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    return (
        <AmountOperationBox>
            <ToastContainer />
            <form id="login-form" name="login-form" className="nobottommargin">
                <div className="row divcenter col-md-12 p-2">
                    <div className="col-md-5 pt-2">
                        <p className="nopadding nomargin">{ title }</p>
                    </div>

                    <div className="col-md-4">
                        <input type="text" id="Amount"
                               name="Amount"
                               className="form-control not-dark"/>
                    </div>
                    <div className="col-md-3 nobottommargin">
                        <Button className="button button-3d button-black nomargin"
                                id="login-form-submit"
                                name="login-form-submit"
                                onClick={notify}
                            >
                            { button }
                        </Button>
                    </div>
                </div>
            </form>
        </AmountOperationBox>
    );
};

export default AmountOperation;
